import classNames from 'classnames';
import React from 'react';
import {Filters} from '../../../../../gallery/components/Filters/Filters';
import s from './MobileFiltersModal.scss';

import FocusTrap from 'focus-trap-react';
import {IGalleryGlobalProps} from '../../../../../gallery/galleryGlobalStrategy';
import {withGlobals} from '../../../../../globalPropsContext';

export interface IMobileFiltersModal extends IGalleryGlobalProps {
  className: string;
  clearFilters: Function;
  closeModal: Function;
  isOpen: boolean;
  shouldShowClearFilters: boolean;
  modalRef: React.RefObject<HTMLDivElement>;
  filtersBtnRef: React.RefObject<HTMLButtonElement>;
  modalHeaderId: string;
  combineFiltersAndSort?: boolean;
}

class MobileFiltersModalComp extends React.Component<IMobileFiltersModal> {
  public state = {
    activeTrap: this.props.isOpen,
    isOpeningModal: false,
  };

  public componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({activeTrap: this.props.isOpen});
      this.updateInertAttribute();
    }
  }

  public componentDidMount(): void {
    this.updateInertAttribute();
  }

  public updateInertAttribute() {
    const modalDiv = this.props.modalRef.current;
    if (this.props.isOpen) {
      modalDiv?.removeAttribute('inert');
    } else {
      modalDiv?.setAttribute('inert', '');
    }
  }

  public showModalAnimation(isOpeningModal: boolean) {
    window.requestAnimationFrame(() => {
      if (!this.state.isOpeningModal) {
        this.setState({isOpeningModal});
      }
    });
  }

  public render() {
    const {isOpen, shouldShowClearFilters, clearFilters, closeModal, combineFiltersAndSort, modalHeaderId, modalRef} =
      this.props;
    const {isPreviewMode} = this.props.globals;

    if (isOpen && !this.state.isOpeningModal) {
      this.showModalAnimation(true);
    } else if (!isOpen && this.state.isOpeningModal) {
      this.showModalAnimation(false);
    }

    const classnames = classNames(s.MobileHorizontalOrientationNotCSSPB, {
      [s.modal]: true,
      [s.open]: isOpen && this.state.isOpeningModal,
      [s.closed]: !isOpen && !this.state.isOpeningModal,
      [s.preview]: isPreviewMode,
    });

    const filtersModal = (
      <div
        className={classnames}
        data-hook="mobile-filters-modal"
        tabIndex={-1}
        role={'dialog'}
        aria-labelledby={modalHeaderId}
        aria-modal={isOpen}
        ref={modalRef}>
        <Filters
          shouldShowClearFiltersButton={shouldShowClearFilters}
          clearFilters={clearFilters}
          modalHeaderId={modalHeaderId}
          combineFiltersAndSort={combineFiltersAndSort}
        />
      </div>
    );

    return (
      <FocusTrap
        active={this.state.activeTrap}
        focusTrapOptions={{
          initialFocus: /* istanbul ignore next reason: tested in sled */ () => this.props.modalRef.current,
          fallbackFocus: () => this.props.modalRef.current,
          onDeactivate: () => closeModal(),
          returnFocusOnDeactivate: false,
          setReturnFocus: /* istanbul ignore next */ () => this.props.filtersBtnRef.current,
        }}>
        {filtersModal}
      </FocusTrap>
    );
  }
}

export const MobileFiltersModal = withGlobals(MobileFiltersModalComp);
